<template>
  <transition name="fade">
    <div id="loader_container">
      <div>
        <Loader />
        <h1 v-if="loaderTitle">
          {{ loaderTitle }}
        </h1>
        <span v-if="loaderText" class="pre-text">
          {{ loaderText }}
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import Loader from "@/components/core/Loader.vue";

export default {
  name: "LoaderGeneral",
  components: {
    Loader
  },
  computed: {
    loaderTitle() {
      return this.$store.state.loaderTitle;
    },
    loaderText() {
      return this.$store.state.loaderText;
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#loader_container {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  position: absolute;
  display: flex;
  text-align: center;
  margin-top: -80px;
}

#loader_container div {
  max-width: 600px;
  padding: 0px 20px;
  margin: auto;
  text-align: center;
}

#loader_container div h1 {
  font:
    500 18px/24px "BentonSansBBVA-Medium",
    Helvetica,
    Arial,
    sans-serif;
  margin: 8px 0px 0px;
}

.pre-text {
  font:
    350 18px/24px "BentonSansBBVA-Book",
    Helvetica,
    Arial,
    sans-serif;
  white-space: pre-line;
  display: inline-block;
  max-width: 330px;
}

@media (max-width: 600px) {
  #loader_container div h1 {
    font-size: 15px;
    max-width: 200px;
    justify-self: center;
    text-align: center;
    margin: 16px auto 8px;
  }

  .pre-text {
    font-size: 15px;
    max-width: 288px;
  }
}
</style>
